import AccordionContainer from "./components/AccordionContainer";
import ActionButtons from "../../../client-followup-form/components/ActionButtons";
import Colors from "../../../../../global/Colors";
import RenderQuestion from "./components/RenderQuestion";
import Svg from "../../../../../ui library/components/svgs/standard/svg";

const DynamicSection = ({ data }) => {
  const colorIcon = Colors.blue[700];
  const sxIcon = { width: "1.5rem" };
  return (
    <>
      {data.sections.map((section) => (
        <AccordionContainer
          key={section.header}
          title={section.header}
          icon={
            <Svg name="his-calendar-search" color={colorIcon} sx={sxIcon} />
          }
        >
          {Object.values(section)
            .filter((item) => typeof item === "object" && item.module)
            .map((question, qIdx) => RenderQuestion(question, qIdx))}
        </AccordionContainer>
      ))}

      <ActionButtons />
    </>
  );
};

export default DynamicSection;
